module.exports = __webpack_public_path__ + "img/masks-envelope.9cd3252b.jpg";